import React, { useState, useRef, useEffect } from 'react';
import { useBus, useListener as eventListener } from 'react-bus';

import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { Popup } from "@progress/kendo-react-popup";

export default function DropDownSelector(props) {

	const { currentItem, items, itemSelected, description } = props;
	const [menuVisible, setMenuVisible] = useState(false);
	const anchor = useRef(null);
	const popupRef = useRef(null);
	const eventBus = useBus();

	const documentClickListener = () => {
		if (menuVisible) {
			setMenuVisible(false);
		}
	};

	eventListener('documentClicked', () => {
		if (menuVisible) {
			setMenuVisible(false);
		}
	});

	const menuClicked = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setMenuVisible(!menuVisible);
		eventBus.emit('documentClicked');
		return false;
	};
	
	const menuKeyDown = (e) => {
		if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'ArrowDown') {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		setMenuVisible((visible) => !visible);
		eventBus.emit('documentClicked');
	};

	const selectorBlurred = () => {
		requestAnimationFrame(() => {
			const focusedElement = document.activeElement;
			const focusIsInSelector =
				anchor.current && anchor.current.contains(focusedElement);
			const focusIsInPopup =
				popupRef.current && popupRef.current.contains(focusedElement);

			if (!focusIsInSelector && !focusIsInPopup) {
				setMenuVisible(false);
			}
		});
	};

	const itemClicked = ({ item: { data } }) => {
		setMenuVisible(false);
		itemSelected(data);
	};

	const getLabel = () => {
		return (
			<span>{currentItem.name}</span>
		);
	};

	const getDropDown = () => {
		return (
			<React.Fragment>
				<div
					className="constituo-drop-down-selector"
					onClick={menuClicked}
					onBlur={selectorBlurred}
					style={{ cursor: "pointer" }}
					ref={anchor}
				>
					<span>{currentItem.name}</span>
					<span
						tabIndex={props.tabIndex}
						aria-label={description}
						role="button"
						aria-haspopup="menu"
						aria-expanded={menuVisible}
						onKeyDown={menuKeyDown}
						className="constituo-drop-down-selector-button k-icon k-i-arrow-chevron-down"
						style={{ paddingLeft: "10px" }}
					/>
				</div>
				<Popup
					anchor={anchor.current}
					show={menuVisible}
					popupClass="popup-content"
				>
					<div
						ref={popupRef}
						tabIndex="0"
						onBlur={selectorBlurred}
					>
						<Menu
							vertical={true}
							style={{ display: "inline-block" }}
							onSelect={itemClicked}
						>
							{getItemElems()}
						</Menu>
					</div>
				</Popup>
			</React.Fragment>
		);
	};

	const getItemElems = () => {
		const elems = [];

		for (let i = 0; i < items.length; i++) {
			const item = items[i];

			elems.push(
				<MenuItem
					key={item.id}
					tabIndex={i + 1}
					text={item.name}
					cssClass="constituo-popup-menu-item"
					data={item}
				/>
			);
		}

		return elems;
	};

	useEffect(() => {
		document.addEventListener("click", documentClickListener);

		if (menuVisible && popupRef.current) {
			popupRef.current.focus();
		}

		return () => {
			document.removeEventListener("click", documentClickListener);
		};
	}, [menuVisible]);

	if (items.length > 1) {
		return getDropDown();
	}

	return getLabel();
}